import React from "react";

import { Col, Row } from "react-grid-system";

interface GridSectionProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

function GridSection({ children, style }: GridSectionProps) {
  
  return (
    <Row style={style}>
      <Col>{children}</Col>
    </Row>
  );
}

export default GridSection;
